import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import type { Item } from '@hooks/useCampaignAccounting'
import useReporting from '@hooks/useReporting'

import handleCallbackAction from '@functions/handleCallbackAction'

import type { CampaignModel } from '@models/types'

import StatementHistoryListItem from './StatementHistoryListItem'

interface StatementHistoryProps {
  callbacks: {
    editItem: (item: Item) => void,
  },
  campaign: CampaignModel,
  hasFilteredStatementItems: boolean,
  items: Item[],
  title?: string,
}

const StatementHistory = (props: StatementHistoryProps) => {
  const {
    callbacks, campaign, hasFilteredStatementItems, items, title,
  } = props

  const useReportingPayload = useReporting({
    allowedReports: ['activity_statement'],
    defaultValues: { campaign_id: campaign.id },
    formDeps: [campaign.id],
  })

  const {
    callbacks: { generateReport: generateFn },
  } = useReportingPayload

  const generateReportPayload = {
    callbacks: {
      action: () => generateFn({ campaign }),
    },
    toastText: 'Report Queued',
  }

  return (
    <DashboardModule
      boxProps={{ marginBottom: 'large' }}
      contentBoxProps={{ flexDirection: 'column' }}
      title={title || 'Statement History'}
    >
      {hasFilteredStatementItems && items.map(item => (
        <StatementHistoryListItem
          // @ts-expect-error TS2741
          callbacks={callbacks}
          key={item.id}
          item={item}
        />
      ))}

      {!hasFilteredStatementItems && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Statement Items Present.
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please adjust your filters.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      <DashboardModule.Footer boxProps={{ borderTop: 'none' }}>
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faDownload} />}
          onClick={() => handleCallbackAction(generateReportPayload)}
          size="medium"
          // @ts-expect-error TS2322
          width={['100%', 'fit-content']}
        >
          Download Statement
        </Button>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default StatementHistory
